module.exports = __webpack_public_path__ + "img/1579479495.2fb73189.jpg";